/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// =============================================================================
// Ação bloqueada por escopo de PDV — botão desabilitado + motivo no hover.
//
// ⚠️ O tooltip mora no WRAPPER, não no botão. Elemento com atributo `disabled`
// não recebe eventos de ponteiro, então `title` num botão desabilitado
// simplesmente nunca aparece — o operador veria o botão cinza e nenhuma
// explicação. O `<span>` externo é quem recebe o hover.
//
// O `disabled` é imposto por clonagem, não pedido ao call site: assim é
// impossível existir tooltip de bloqueio num botão que continua clicável (o
// mesmo princípio do `EntityActionBar`, que impõe o porte aos filhos).
//
// Isto é barreira de CONVENIÊNCIA. A autorização real é do backend, e o guard
// de request (`_skipForbiddenRedirect` + toast) cobre o caso de alguém
// reabilitar o botão pelo inspetor.
// =============================================================================

const BlockedWrap = styled.span`
   display: inline-flex;
   cursor: not-allowed;

   /* O filho já vem desabilitado; isto evita que o clique alcance o botão em
      navegadores que ainda propagam o evento pelo wrapper. */
   > * {
      pointer-events: none;
   }
`;

export default function GuardedAction({ reason, children }) {
   if (!reason) return children;

   return (
      <BlockedWrap title={reason} aria-label={reason}>
         {React.cloneElement(children, { disabled: true })}
      </BlockedWrap>
   );
}

GuardedAction.propTypes = {
   // Motivo do bloqueio; `null` renderiza o filho intacto.
   reason: PropTypes.string,
   children: PropTypes.element.isRequired,
};
